import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { MovuRobotics_FlowService } from './MovuRobotics.flow.index';

import { app_TestService } from './app.flow.index';
import { app_custom_activate_container_on_successService } from './app.flow.index';
import { app_custom_execute_shipment_download_requestService } from './app.flow.index';
import { app_custom_get_instance_informationService } from './app.flow.index';
import { app_custom_map_pallet_induction_request_payloadService } from './app.flow.index';
import { app_custom_map_pick_request_detailsService } from './app.flow.index';
import { app_custom_pick_confirmation_on_failureService } from './app.flow.index';
import { app_custom_pick_request_on_failureService } from './app.flow.index';
import { app_custom_pick_request_processorService } from './app.flow.index';
import { app_custom_shipment_download_on_failureService } from './app.flow.index';
import { app_custom_shipment_download_on_successService } from './app.flow.index';
import { app_custom_shipment_download_verificationService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.MovuRobotics = this.injector.get(MovuRobotics_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public MovuRobotics: MovuRobotics_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _Test: app_TestService;
  public async Test($inParams: {  }): Promise< { outputDetails?: string[] }> {
    if(!this._Test) { 
      this._Test = this.injector.get(app_TestService);
    }
    return this._Test.run($inParams);
  }
   
   

   
 
  private _custom_activate_container_on_success: app_custom_activate_container_on_successService;
  public async custom_activate_container_on_success($inParams: { loadContainerId?: number, locationId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._custom_activate_container_on_success) { 
      this._custom_activate_container_on_success = this.injector.get(app_custom_activate_container_on_successService);
    }
    return this._custom_activate_container_on_success.run($inParams);
  }
   
   

   
 
  private _custom_execute_shipment_download_request: app_custom_execute_shipment_download_requestService;
  public async custom_execute_shipment_download_request($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number }): Promise< { outputDetails?: string[] }> {
    if(!this._custom_execute_shipment_download_request) { 
      this._custom_execute_shipment_download_request = this.injector.get(app_custom_execute_shipment_download_requestService);
    }
    return this._custom_execute_shipment_download_request.run($inParams);
  }
   
   

   
 
  private _custom_get_instance_information: app_custom_get_instance_informationService;
  public async custom_get_instance_information($inParams: {  }): Promise< { application_name?: string, environment?: string, footprint_alert_topic?: string, footprint_alert_workflow_code?: string }> {
    if(!this._custom_get_instance_information) { 
      this._custom_get_instance_information = this.injector.get(app_custom_get_instance_informationService);
    }
    return this._custom_get_instance_information.run($inParams);
  }
   
   

   
 
  private _custom_map_pallet_induction_request_payload: app_custom_map_pallet_induction_request_payloadService;
  public async custom_map_pallet_induction_request_payload($inParams: { licensePlateId?: number, taskId?: number, storageTransactionId?: string }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.PalletInduction }> {
    if(!this._custom_map_pallet_induction_request_payload) { 
      this._custom_map_pallet_induction_request_payload = this.injector.get(app_custom_map_pallet_induction_request_payloadService);
    }
    return this._custom_map_pallet_induction_request_payload.run($inParams);
  }
   
   

   
 
  private _custom_map_pick_request_details: app_custom_map_pick_request_detailsService;
  public async custom_map_pick_request_details($inParams: { taskId?: number }): Promise< { outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.PalletRequestDetails }> {
    if(!this._custom_map_pick_request_details) { 
      this._custom_map_pick_request_details = this.injector.get(app_custom_map_pick_request_detailsService);
    }
    return this._custom_map_pick_request_details.run($inParams);
  }
   
   

   
 
  private _custom_pick_confirmation_on_failure: app_custom_pick_confirmation_on_failureService;
  public async custom_pick_confirmation_on_failure($inParams: { Task_id?: string, wh_id?: string, Srcloc?: string, Pallet_id?: string, Success?: any, error_message?: string }): Promise< { reason?: string }> {
    if(!this._custom_pick_confirmation_on_failure) { 
      this._custom_pick_confirmation_on_failure = this.injector.get(app_custom_pick_confirmation_on_failureService);
    }
    return this._custom_pick_confirmation_on_failure.run($inParams);
  }
   
   

   
 
  private _custom_pick_request_on_failure: app_custom_pick_request_on_failureService;
  public async custom_pick_request_on_failure($inParams: { warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise< { reason?: string }> {
    if(!this._custom_pick_request_on_failure) { 
      this._custom_pick_request_on_failure = this.injector.get(app_custom_pick_request_on_failureService);
    }
    return this._custom_pick_request_on_failure.run($inParams);
  }
   
   

   
 
  private _custom_pick_request_processor: app_custom_pick_request_processorService;
  public async custom_pick_request_processor($inParams: { taskId?: number, warehouseId?: number }): Promise<void> {
    if(!this._custom_pick_request_processor) { 
      this._custom_pick_request_processor = this.injector.get(app_custom_pick_request_processorService);
    }
    return this._custom_pick_request_processor.run($inParams);
  }
   
   

   
 
  private _custom_shipment_download_on_failure: app_custom_shipment_download_on_failureService;
  public async custom_shipment_download_on_failure($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._custom_shipment_download_on_failure) { 
      this._custom_shipment_download_on_failure = this.injector.get(app_custom_shipment_download_on_failureService);
    }
    return this._custom_shipment_download_on_failure.run($inParams);
  }
   
   

   
 
  private _custom_shipment_download_on_success: app_custom_shipment_download_on_successService;
  public async custom_shipment_download_on_success($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> {
    if(!this._custom_shipment_download_on_success) { 
      this._custom_shipment_download_on_success = this.injector.get(app_custom_shipment_download_on_successService);
    }
    return this._custom_shipment_download_on_success.run($inParams);
  }
   
   

   
 
  private _custom_shipment_download_verification: app_custom_shipment_download_verificationService;
  public async custom_shipment_download_verification($inParams: { taskId?: number, warehouseId?: number }): Promise<void> {
    if(!this._custom_shipment_download_verification) { 
      this._custom_shipment_download_verification = this.injector.get(app_custom_shipment_download_verificationService);
    }
    return this._custom_shipment_download_verification.run($inParams);
  }
   
   

   
}
